import { Component, OnInit, Input } from '@angular/core';
import { EMPTY, Subscription } from 'rxjs';
import { BroadcastingsService } from 'src/app/services/broadcastings-services/broadcastings.service';
import { BroadcastingInfo } from 'src/app/models/broadcastings-models/broadcasting-info.model';
import { Router, ActivatedRoute } from '@angular/router';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Schedule } from 'src/app/models/schedule-models/schedule.model';
import { FormControl } from '@angular/forms';
import { catchError, tap } from 'rxjs/operators';

@Component({
  selector: 'app-broadcastings-broadcasting-schedules-card',
  templateUrl: './broadcastings-broadcasting-schedules-card.component.html',
  styleUrls: ['./broadcastings-broadcasting-schedules-card.component.scss']
})
export class BroadcastingsBroadcastingSchedulesCardComponent implements OnInit {

  @Input() broadcasting: BroadcastingInfo;
  @Input() existingSchedules: Schedule[];
  schedules;
  existingSchedule = new FormControl(null);
  updateSchedulesSubscription: Subscription;

  constructor(private broadcastingsService: BroadcastingsService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private snackbarService: SnackBarService) {
  }

  ngOnInit() { }

  public formatScheduleDate(value: number, timeZone: string): string {
    if (typeof value !== 'number') { return ''; }

    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit', month: '2-digit', year: 'numeric', timeZone: timeZone || undefined
    };
    try {
      return new Intl.DateTimeFormat('en-GB', options).format(value);
    } catch (error) {
      // Match the edit form's local-date fallback if the server sends an invalid time zone.
      options.timeZone = undefined;
      return new Intl.DateTimeFormat('en-GB', options).format(value);
    }
  }

  public addSchedule() {
    if (this.existingSchedule.value === null) {
      this.router.navigate(['schedule'], { relativeTo: this.activatedRoute });
    } else {
      this.broadcastingsService.linkExistingBroadcastingSchedule(this.existingSchedule.value.InternalId, this.broadcasting.BroadcastingInternalId).pipe(
        tap(o => this.broadcastingsService.refreshBroadcasting()),
        tap(o => this.existingSchedule.patchValue(null))
      ).subscribe();
    }
  }

  public editSchedule(schedule) {
    this.router.navigate(['schedule', schedule.InternalId], { relativeTo: this.activatedRoute });
  }

  public deleteSchedule(schedule) {
    this.updateSchedulesSubscription = this.broadcastingsService.deleteBroadcastingSchedule(schedule.InternalId, this.broadcasting.BroadcastingInternalId).pipe(
      tap(o => this.snackbarService.open('broadcastings-page.snackbar messages.update broadcasting success', 'success')),
      tap(o => this.broadcastingsService.refreshBroadcasting()),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

}
